module.exports = __webpack_public_path__ + "img/logo-collapse.dc5f9a6b.svg";